module.exports = __webpack_public_path__ + "img/LUCK.85e671b0.png";